import { render } from "./Logo.vue?vue&type=template&id=646200aa&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=646200aa&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-646200aa"

export default script